import React from 'react';
import type { ContentfulVideoAsset } from '../Section/SectionSettings';

const BackgroundVideo = ({ url }:ContentfulVideoAsset) => (
  <video
    src={url}
    autoPlay
    muted
    loop
    playsInline
    className="absolute w-full h-full max-h-[600px] object-cover z-0"
  />
);

export default BackgroundVideo;
